import type { NextPage } from 'next'
import Head from 'next/head'

import { OurStorySlice } from '@/slices/About/OurStorySlice'
import { Layout } from '@/slices/Layout'
import { getLayoutProps } from '@/slices/Layout/global/layout'

const OurStoryPage: NextPage = () => {
  const layoutProps = getLayoutProps()

  return (
    <>
      <Head>
        <title>Our Story | Pixie World</title>
        <meta
          name="description"
          content="Learn about the story behind Pixie World and our mission to create personalized storybooks."
        />
      </Head>

      <Layout {...layoutProps}>
        <OurStorySlice />
      </Layout>
    </>
  )
}

export default OurStoryPage
